import { Header } from 'components/molecules';
import { ListRoleTemplate } from 'components/templates';
import { withAuth } from 'HOCs';

const breadcrumbs = [{ label: 'Administración' }];

const ListRolePage = () => {
  return (
    <>
      <Header
        title="Roles"
        subtitle="Crea, edita, lista y elimina roles"
        breadCrumbsProps={{ breadcrumbs: breadcrumbs }}
      />
      <ListRoleTemplate />
    </>
  );
};

export default withAuth(ListRolePage);
